import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FreelancerForm } from "./FreelancerForm";
import { Freelancer } from "@/types/freelancer";
import { useFreelancersInvalidate } from "@/hooks/use-freelancers-invalidate";

interface FreelancerEditModalProps {
  freelancer: Freelancer;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpdate: () => void;
}

export function FreelancerEditModal({ freelancer, open, onOpenChange, onUpdate }: FreelancerEditModalProps) {
  const invalidateFreelancers = useFreelancersInvalidate();

  const handleSuccess = async () => {
    invalidateFreelancers();
    onOpenChange(false);
    onUpdate();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Editar Freelancer - {freelancer?.nome}</DialogTitle>
        </DialogHeader>
        {freelancer && <FreelancerForm freelancer={freelancer} onSuccess={handleSuccess} />}
      </DialogContent>
    </Dialog>
  );
}
